import { BulletListContent, H3, Ul } from '@vp/swan';
import { ServiceDetailsPageDataQuery } from '../../graphql';

export type InclusionsProps = {
    title: string;
    inclusions: ServiceDetailsPageDataQuery['serviceDetailPage']['inclusions'];
};

export function Inclusions(props: InclusionsProps) {
    return (
        <div>
            <H3 fontSkin="title-subsection" id="inclusions-list">
                {props.title}
            </H3>
            <Ul aria-labelledby="inclusions-list" skin="checkmark">
                {props.inclusions.map((inclusion) => (
                    <li>
                        <BulletListContent>{inclusion.description}</BulletListContent>
                    </li>
                ))}
            </Ul>
        </div>
    );
}
